export { default } from './with-add-incentive-to-cart';
